/*
 * Translate banner messages
 *
 * This contains all the text for the TranslateBanner component.
 */
import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  cancelButton: {
    id: 'app.components.TranslateBanner.cancelButton',
    defaultMessage: 'Do not ask me again',
  },
  confirmButton: {
    id: 'app.components.TranslateBanner.confirmButton',
    defaultMessage: 'Sure!',
  },
  text: {
    id: 'app.components.TranslateBanner.text',
    defaultMessage: 'Hi! Would you like to try {brandName} in {language}?',
  },
  'en-US': {
    id: 'app.components.TranslateBanner.en-us',
    defaultMessage: 'English',
  },
  'es-US': {
    id: 'app.components.TranslateBanner.es-us',
    defaultMessage: 'Spanish',
  },
  'pt-BR': {
    id: 'app.components.TranslateBanner.pt-br',
    defaultMessage: 'Portuguese',
  },
});
